import {
  MEALS_INCLUDED_OPTIONS,
  ROOM_TYPE_OPTIONS,
} from '@/modules/Search/components/HotelResults/HotelResultsFilter/HotelResultsFilter.constants'

export const ROOM_TYPE_LIST = ROOM_TYPE_OPTIONS
export const MEALS_INCLUDED_LIST = MEALS_INCLUDED_OPTIONS

export const HOTEL_STAR_RATING_OPTIONS = [
  {
    title: 'search.form.hotelRating.options.topRated',
    value: 5,
  },
  {
    title: 'search.form.hotelRating.options.excellent',
    value: 4,
  },
  {
    title: 'search.form.hotelRating.options.greatValue',
    value: 3,
  },
  {
    title: 'search.form.hotelRating.options.basicStays',
    value: 2,
  },
  {
    title: 'search.form.hotelRating.options.allRatedHotels',
    value: 1,
  },
  {
    title: 'search.form.hotelRating.options.nonRated',
    value: 0,
  },
]
